import http from '../api/api'
import config from '../api/constants'

const cardlessViewToken = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'CARDLESS_VIEWTOKEN',
      module: 'CARDLESSCASHOUT',
    }
    const response = await http.post(config.apiRoute.cardlessViewToken, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const cardlessGenTokenVerify = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'CARDLESS_GENTOKEN_VER',
      module: 'CARDLESSCASHOUT',
      otp: '',
    }
    const response = await http.post(config.apiRoute.cardlessGenTokenVerify, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const cardlessGenToken = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'CARDLESS_GENTOKEN',
      module: 'CARDLESSCASHOUT',
    }
    const response = await http.post(config.apiRoute.cardlessGenToken, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const cardlessCancelToken = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'CARDLESS_CANCELTOKEN',
      module: 'CARDLESSCASHOUT',
    }
    const response = await http.post(config.apiRoute.cardlessCancelToken, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const getAllAccounts = async () => {
  try {
    const reqParams = {
      requestId: 'ACCOUNTDETAILS',
      accountType: 'S',
    }
    const response = await http.post(config.apiRoute.GET_ACCOUNTS, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}
const CardLessService = {
  cardlessViewToken,
  cardlessGenToken,
  cardlessGenTokenVerify,
  cardlessCancelToken,
  getAllAccounts
}
export default CardLessService
